import axios from 'axios'
import { SecretsManagerClient, GetSecretValueCommand } from '@aws-sdk/client-secrets-manager'

export class BaseClient {
    constructor(url, secretName, axiosOptions) {
        if (!url)
            throw new Error("'url' must be defined")

        this.url = url
        this.secretName = secretName
        this.secureAxiosInstance = null
        this.axiosInstance = null

        this.axiosOptions = axiosOptions
    }

    async createSecureAxiosInstance(customHeaders = {}, contentType = null) {
        // Checking if the instance exists with the same headers and content type
        if (
            this.secureAxiosInstance && 
            JSON.stringify(this.secureCustomHeaders) === JSON.stringify(customHeaders) && 
            JSON.stringify(this.secureContentType) === JSON.stringify(contentType)
        ) {
            return
        }

        if (!this.secretName)
            throw new Error("'secretName' must be defined")

        const secretsManagerClient = new SecretsManagerClient()

        const { SecretString } = await secretsManagerClient.send(new GetSecretValueCommand({ SecretId: this.secretName }));

        const secretObject = JSON.parse(SecretString)

        this.secureCustomHeaders = customHeaders
        this.secureContentType = contentType

        this.secureAxiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                "content-type": contentType ?? "application/json",
                Authorization: secretObject.accessToken,
                ...customHeaders
            },
            ...this.axiosOptions
        });
    }

    createAxiosInstance(customHeaders = {}, contentType = null) {
        // Checking if the instance exists with the same headers and content type
        if (
            this.axiosInstance && 
            JSON.stringify(this.customHeaders) === JSON.stringify(customHeaders) && 
            JSON.stringify(this.contentType) === JSON.stringify(contentType)
        ) {
            return
        }

        this.customHeaders = customHeaders
        this.contentType = contentType

        this.axiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                "content-type": contentType ?? "application/json",
                ...customHeaders
            },
            ...this.axiosOptions
        });
    }
}
